<template>
    <div>
        <rating-directions-grid
                :items="items"
                :total="total"
                :loading="loading"
                @paginate="onPaginate"
                @editItem="editItem"
                @deleteItem="deleteItem"
                @navigateTo="navigateTo"
        >
        </rating-directions-grid>

        <v-dialog v-model="dialog" max-width="850px" scrollable>
            <add-edit-rating-direction
                    v-if="dialog"
                    @shouldCloseAddEdit="dialog = false"
                    @addedEdited="addedEdited"
                    :edit-mode="editMode"
                    :edit-id="editId"
            ></add-edit-rating-direction>
        </v-dialog>

        <v-dialog v-model="dialogRemove" max-width="290">
            <delete-confirm
                    @shouldCloseDeleteConfirm="dialogRemove = false"
                    @removed="removed"
                    :delete-id="deleteId"
            >
            </delete-confirm>
        </v-dialog>

        <v-btn
                color="primary"
                dark
                fixed
                bottom
                right
                fab
                @click="addItem()"
        >
            <v-icon>add</v-icon>
        </v-btn>
    </div>
</template>
<script>
    import HttpService from "../../../HttpService";
    import RatingDirectionsGrid from "./RatingDirectionsGrid";
    import {objectQueryStringify} from "../../../helpers/querystringHelper";
    import AddEditRatingDirection from "./AddEditRatingDirection";
    import DeleteConfirm from "./DeleteConfirm";

    export default {
        components: {
            RatingDirectionsGrid,
            AddEditRatingDirection,
            DeleteConfirm
        },
        data: () => {
            return {
                dialog: false,
                dialogRemove: false,
                editId: null,
                editMode: false,
                deleteId: null,
                items: [],
                total: null,
                loading: false,
                pagination: {
                    totalItems: 0,
                }
            }
        },
        methods: {
            navigateTo(directionId, routeName) {
                this.$router.push({
                    name: routeName, 
                    params: {
                        direction: directionId,
                    }
                }).catch(err => {});  
            },
            getItems(queryParams) {
                this.loading = true;

                HttpService.getInstance()
                    .get(`ratingDirections?${queryParams}`)
                    .then(items => {
                        this.items = items.items;
                        this.total = items.total;
                        
                        this.loading = false;
                    })
            },
            onPaginate(paginationData) {
                if (this.items.length === 0 || 
                    JSON.stringify(this.pagination) !== JSON.stringify(paginationData)) {
                    this.getItems(objectQueryStringify(paginationData));
                }

                this.pagination = paginationData;
            },
            addItem() {
                this.dialog = true;
                this.editId = null;
                this.editMode = false;
            },
            editItem(itemId) {
                this.dialog = true;
                this.editId = itemId;
                this.editMode = true;
            },
            addedEdited() {
                this.dialog = false;
                this.editId = null;

                this.getItems(objectQueryStringify(this.pagination));
            },
            deleteItem(itemId) {
                this.dialogRemove = true;
                this.deleteId = itemId;
            },
            removed() {
                this.dialogRemove = false;
                this.deleteId = null;

                this.getItems(objectQueryStringify(this.pagination));
            },
        },
    }
</script>